<template>
  <app-form-select
    :datas="companyAnnualTurnovers"
    :labelText="labelText ?? $t('general.company_annual_turnover')"
    :errorMessage="errorMessage"
    :serverMessage="serverMessage"
    :loading="loading"
    :showLabel="showLabel"
    :allowFilter="allowFilter"
    v-model="checkedValue"
    v-on:retry="getCompanyAnnualTurnovers"
    v-on:valueSelected="onValueSelected"
  />
</template>

<script>
export default {
  props: {
    labelText: {
      type: String,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    allowFilter: {
      type: Boolean,
      default: true,
    },
    errorMessage: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: Object,
      default: () => {},
    },
    country_id: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    country_id: function (newVal, oldValue) {
      this.getCompanyAnnualTurnovers(newVal);
    },
    companyAnnualTurnovers(companyAnnualTurnovers) {
      if (this.$lodash.isEmpty(companyAnnualTurnovers)) {
        this.onValueSelected(null);
      }
    },
  },
  computed: {
    checkedValue: {
      get() {
        if (this.$lodash.isEmpty(this.companyAnnualTurnovers)) {    
          return {};
        }
        return this.modelValue ?? [];
      },
      set(value) {
        this.onValueSelected(value);
      },
    },

    companyAnnualTurnovers() {
      return this.$store.getters["referenceStore/companyAnnualTurnovers"];
    },

    loading() {
      return this.$store.getters["referenceStore/loading"];
    },

    serverMessage() {
      return this.$store.getters["referenceStore/message"] ?? "";
    },
  },

  async mounted() {
    this.getCompanyAnnualTurnovers();
  },

  methods: {
    async getCompanyAnnualTurnovers() {
      this.$store.commit("referenceStore/resetState");
      this.$store.dispatch(
        "referenceStore/getCompanyAnnualTurnovers",
        this.country_id
      );
    },

    onValueSelected(value) {
      this.$emit("update:modelValue", value);
    },
  },
};
</script>


